export default __webpack_public_path__ + "images/close.e6417a91.svg";